import { cn } from '@/utils/twMerge'
import { PrismicRichText } from '@prismicio/react'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

const SocialProofStats = ({ item, stats, uid }: { item: DataObject; stats: DataObject; uid?: string }) => {
  return (
    <div>
      <p className="uppercase text-primary-green-85">{item.type}</p>
      <PrismicRichText
        field={item.title}
        components={{
          heading3: ({ children }) => (
            <h3 className={cn('mb-8 mt-4 max-w-md', uid === 'request-cmmc-demo' && 'text-white')}>{children}</h3>
          ),
        }}
      />
      <div
        className={cn(
          'mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3',
          ['nist', 'cmmc', 'request-cmmc-demo'].includes(uid as string) && 'md:!grid-cols-2',
        )}>
        {stats.map((item: ItemObject, index: number) => {
          const key = `i-${index}`
          return (
            <div key={key} className="flex flex-col items-center justify-start">
              <p
                className={cn(
                  'bg-gradient-to-r bg-clip-text p-5 text-[calc(2.325rem+.9vw)] tracking-[-1.28px] text-transparent xl:text-[4rem]',
                  uid === 'request-cmmc-demo'
                    ? 'from-[#0FD082] to-[#C6FBE5]'
                    : 'from-primary-green-85 to-primary-ink-100',
                )}>
                {item.number} <span className="-ml-2">{item.symbol}</span>
              </p>
              <p
                className={cn(
                  'text-center text-xl',
                  uid === 'request-cmmc-demo' && 'text-white/80',
                  ['nist', 'cmmc', 'request-cmmc-demo'].includes(uid as string) && 'max-w-[250px]',
                )}>
                {item.description}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SocialProofStats
